import { VFC } from 'react';
import style from './AtDots.module.scss';

export const AtDots: VFC = () => (
  <div className={style.container}>
    <div className={` ${style.leftDot} `} />
    <div className={` ${style.rightDot} `} />
  </div>
);
